// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-container {
    width: 50%;
    margin: 0 auto;
    text-align: left;
  }
  
  .summary-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .summary-table td {
    padding: 5px 10px;
  }
  
  .total-row {
    font-weight: bold;
  }
  
  .grand-total {
    font-weight: bold;
    font-size: 1.2em;
  }
  
  .signature {
    text-align: right;
    margin-top: 40px;
  }
  
  .signature .line {
    width: 200px;
    height: 1px;
    background-color: black;
    margin: 0 auto 10px auto;
  }
  
  .signature p {
    margin: 0;
  }`, "",{"version":3,"sources":["webpack://./src/views/pages/end-customer/components/summary/summary.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX","sourcesContent":[".summary-container {\r\n    width: 50%;\r\n    margin: 0 auto;\r\n    text-align: left;\r\n  }\r\n  \r\n  .summary-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .summary-table td {\r\n    padding: 5px 10px;\r\n  }\r\n  \r\n  .total-row {\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .grand-total {\r\n    font-weight: bold;\r\n    font-size: 1.2em;\r\n  }\r\n  \r\n  .signature {\r\n    text-align: right;\r\n    margin-top: 40px;\r\n  }\r\n  \r\n  .signature .line {\r\n    width: 200px;\r\n    height: 1px;\r\n    background-color: black;\r\n    margin: 0 auto 10px auto;\r\n  }\r\n  \r\n  .signature p {\r\n    margin: 0;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
